export const VERSION_NUMBER = '1.201';
export const BUILD_TIME = '2023-07-07T19:16:50.698Z';
export const BUILD_NOTES = `
<ul>
    <li>Added requirement for board members to specify request priority during request creation.</li>
</ul>`;
